import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faEdit, faHashtag, faTimes } from '@fortawesome/free-solid-svg-icons';

class RecuperarContrasena extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        codigo_verificacion: '',
        password1: '',
        password2: '',
        usuario: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const id_usuario = document.getElementById('id_usuario').value;
        const { codigo_verificacion, password1, password2 } = this.state;
        var errores = [];
        if (!codigo_verificacion) { errores.push("error_codigo_verificacion"); }
        if (!password1) { errores.push("error_password1"); }
        if (!password2) { errores.push("error_password2"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        if (password1 !== password2) {
            Swal.fire(
                'Usuarios!',
                'Las Contraseñan no coinciden.',
                'error'
            )
            return false
        }
        // let form = document.getElementById('form');
        // let formData = new FormData(form);
        // console.log(formData);
        Swal.showLoading();
        var datosEnviar = {
            id_usuario: id_usuario,
            codigo_verificacion: codigo_verificacion,
            password1: password1,
            password2: password2
        }
        authAxios.post("usuario/recuperar_contrasena", datosEnviar)
            .then((datosRespuesta) => {
                if (datosRespuesta.data.Status) {
                    Swal.fire(
                        'Usuario!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/");
                } else {
                    Swal.fire(
                        'Error',
                        datosRespuesta.data.msj,
                        'error'
                    );
                }
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("usuario/detail/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                if (datosRespuesta.data.data.edited === 'NO') {
                    this.setState({ datosCargados: true, usuario: datosRespuesta.data.data, load: '' });
                    Swal.close();
                } else {
                    this.props.history.push("/");
                }
            })
            .catch(console.log);
    }
    render() {
        const { load, usuario, codigo_verificacion, password1, password2 } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>RECUPERACIÓN CONTRASEÑA</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <input type="hidden" id='id_usuario' name="id_usuario" value={this.props.match.params.id} />
                                                    <label htmlFor="correo_electronico">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'lowercase' }} type="text" name="correo_electronico" id="correo_electronico" defaultValue={usuario.email}
                                                            className={((this.verificarError("error_correo_electronico")) ? "is-invalid" : "border border-info") + " form-control form-control-sm"}
                                                            placeholder="ejemplo@dominio.com" aria-describedby="helpId" readOnly
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Correo Electrónico</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="codigo_verificacion">Código Verificación</label>
                                                    <input type="number" name="codigo_verificacion" id="codigo_verificacion" value={codigo_verificacion}
                                                        className={((this.verificarError("error_codigo_verificacion")) ? "is-invalid" : "border border-info") + " form-control form-control-sm"}
                                                        placeholder="CÓDIGO VERIFICACIÓN" aria-describedby="helpId" onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Código Verificación</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="password1">Password</label>
                                                    <input type="password" name="password1" id="password1" value={password1}
                                                        className={((this.verificarError("error_password1")) ? "is-invalid" : "border border-info") + " form-control form-control-sm"}
                                                        placeholder="PASSWORD" aria-describedby="helpId" onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Password</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="password2">Confirmar Password</label>
                                                    <input type="password" name="password2" id="password2" value={password2}
                                                        className={((this.verificarError("error_password2")) ? "is-invalid" : "border border-info") + " form-control form-control-sm"}
                                                        placeholder="CONFIRMAR PASS." aria-describedby="helpId" onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Password</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Guardar Cambios</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RecuperarContrasena;